import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface Props {
  name?: string;
  value?: string;
  placeholder?: string;
  onChange?: (field: string, value: any, shouldValidate?: boolean) => void;
}

export default function MyComponent({
  name,
  placeholder,
  value = "",
  onChange,
}: Props) {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handlerOnChange = (_value: string) => {
    setText(_value);
    if (name && onChange) {
      onChange(name, _value);
    }
  };

  const handlerSave = () => {
    if (name && onChange) {
      onChange(name, text);
    }
  };

  const handlerClear = () => {
    setText("");
    if (name && onChange) {
      onChange(name, "");
    }
  };

  return (
    <>
      <ReactQuill
        theme={"snow"}
        placeholder={placeholder}
        value={text}
        modules={modules}
        formats={formats}
        onChange={handlerOnChange}
      />
      <Button onClick={handlerSave}>Salvar</Button>
      <Button onClick={handlerClear}>Limpar</Button>
    </>
  );
}
